// Les RPC lèvent des jetons courts (convention V2). On les traduit ici, une
// seule fois, en phrases qui disent quoi faire — pas en codes techniques.

interface ErreurSupabase { message?: string; details?: string; code?: string }

const MESSAGES: Record<string, string> = {
  unauthenticated:       'Session expirée — reconnecte-toi.',
  run_introuvable:       'Cette run n’existe pas encore. Ouvre-la depuis l’accueil.',
  run_verrouillee:       'Un autre opérateur est dans cette run.',
  run_cloturee:          'La journée est clôturée — plus rien ne s’y écrit.',
  run_deja_cloturee:     'Cette run est déjà clôturée.',
  run_deja_ouverte:      'Cette run est déjà ouverte.',
  etape_introuvable:     'Étape inconnue dans cette run.',
  motif_requis:          'Un motif est obligatoire pour mettre une étape de côté.',
  note_vide:             'La note est vide.',
  branche_inconnue:      'Branche inconnue pour l’étape 05.',
  statut_invalide:       'Statut refusé par le moteur.',
  journee_archivee:      'Cette journée est archivée — elle se consulte dans SotCP V3.',
  journee_not_found:     'Journée absente en base.',
  journee_locked:        'Journée clôturée ou archivée — écriture refusée.',
  journee_not_active:    'La journée n’est plus active.',
  journee_not_closed:    'Seule une journée clôturée peut être rouverte.',
  already_active:        'Cette journée est déjà ouverte.',
  must_use_reopen:       'Journée clôturée — sa réouverture se fait dans SotCP.',
  cannot_reopen_archived:'Journée archivée — elle ne se rouvre pas.',
  max_open_days_reached: 'Trois journées sont déjà ouvertes. Clôtures-en une avant.',
  pad_ref_requis:        'La référence du PAD est obligatoire.',
  pad_introuvable:       'Ce PAD en attente n’existe plus.',
  ticket_not_found:      'Ce ticket n’est pas dans l’import du jour.',
  invalid_status:        'Statut de ticket refusé.',
  section_not_allowed:   'Section d’inventaire inconnue.',
  payment_id_required:   'Paiement sans identifiant.',
  invalid_pad_type:      'Type de PAD inconnu (carte ou chèque).',
  // Levés par mutate_paiement et set_operator_report (§05a). Sans traduction,
  // le jeton brut s'affichait tel quel dans le bandeau.
  not_found:             'Cette ligne n’existe plus — quelqu’un l’a supprimée entre-temps.',
  duplicate:             'Cette ligne existe déjà dans la journée.',
  report_text_too_long:  'Signalement trop long — 2000 caractères au plus.',
}

export function messageErreur(e: unknown): string {
  const err = (e ?? {}) as ErreurSupabase
  const brut = (err.message ?? String(e ?? '')).trim()
  const connu = MESSAGES[brut]
  if (connu) {
    // Le DETAIL porte le nom du tenant du verrou — l'information utile.
    return err.details ? `${connu} (${err.details})` : connu
  }
  if (/Failed to fetch|NetworkError|fetch failed/i.test(brut)) {
    return 'Le serveur est injoignable — mis en attente.'
  }
  return brut || 'Erreur inconnue.'
}

export const jetonErreur = (e: unknown): string =>
  ((e ?? {}) as ErreurSupabase).message?.trim() ?? ''
